import { Navigate } from 'react-router-dom';
import { useAuth } from './Auth/ProvideAuth'

import { ADMIN_ROLE, ROOT_PATH, LOGIN_PATH } from './Config/constants.js';

/* role nullable or role = "roleA" or role = "roleA|roleB" */
const RouteManager = ({ component: Component, role, ...rest }) => {
	let auth = useAuth();

	if(auth.oxygenUser == null) {
		return <Navigate to={{ pathname: LOGIN_PATH }} />
	}
		
	if (role) {
		role = role.split("|");
		if(auth.oxygenUser.roles[0].name !== ADMIN_ROLE && !role.includes(auth.oxygenUser.roles[0].name)) {
			return <Navigate to={{ pathname: ROOT_PATH}} />
		}
	}
	
	return <Component {...rest} />
}

export default RouteManager;